import { lazy, Suspense } from 'react';

import Route from '@components/route';

import { Switch } from 'react-router-dom';
import { Modal } from '@ui/atoms';

import { BannerProvider } from 'react-components/src/components/banner';
import BannerBottomBar from 'react-components/src/shared/settings/components/banner-bottom-bar';
import BannerContainer from 'react-components/src/components/banner/banner-container';
import routes from '.';

const AccountsPage = lazy(() => import('./accounts-page'));
const TransactionsPage = lazy(() => import('./details/transactions/transactions-page'));
const BenefitDetailsPage = lazy(() => import('./details/account'));
const EligibilityCategories = lazy(() => import('./details/account/components/modals/eligibility-categories.modal'));
const BankDetails = lazy(() => import('./details/account/components/modals/bank-details.modal'));
const UpcomingEvents = lazy(() => import('./details/upcoming-events'));
const BenefitRules = lazy(() => import('./details/account/components/modals/benefit-rules.modal'));
const PolicyOverview = lazy(() => import('./details/account/components/modals/policy-overview.modal'));
const PaymentMethodsModal = lazy(() => import('./details/account/components/modals/payment-methods.modal'));
const ReimbursementsPage = lazy(() => import('./details/reimbursement'));
const AllReimbursementsPage = lazy(() => import('./details/reimbursement/pages/all-reimbursements'));
// const PayoutDetailsPage = lazy(() => import('./details/reimbursement/pages/payout-details'));
const TransferModal = lazy(() => import('./details/reimbursement/pages/transfer-modal'));
const TransactionDetailsPage = lazy(() => import('@pages/transactions/details'));
const HSASubmitDocumentsModal = lazy(() => import('./details/account/components/modals/hsa-submit-documents.modal'));
const PortfolioAllocationPage = lazy(() => import('./details/account/hsa-investments/portfolio-allocation'));
const InvestMoreModal = lazy(() => import('./details/account/hsa-investments/invest-more'));
const CashOutModal = lazy(() => import('./details/account/hsa-investments/cash-out'));
const SecurityDetailModal = lazy(() => import('./details/account/hsa-investments/security-detail'));

const Accounts = () => (
  <>
    <BannerProvider>
      <Switch>
        <Route exact path={routes.transactions} title="Transactions">
          <TransactionsPage />
        </Route>

        <Route exact path={routes.payoutDetails} title="Transaction details">
          <TransactionDetailsPage />
        </Route>

        <Route exact path={routes.expenseDetails} title="Transaction details">
          <TransactionDetailsPage />
        </Route>

        <Route exact path={routes.reimbursementTransactionsList} title="Transaction details">
          <AllReimbursementsPage />
        </Route>

        <Route
          exact
          path={[
            routes.details,
            routes.eligibilityCategories,
            routes.reimbursementTransferModal,
            routes.policyOverview,
            routes.benefitRules,
            routes.bankDetails,
            routes.paymentMethods,
            routes.hsaApplicationForm,
            routes.hsaInvestmentsInvestMore,
            routes.hsaInvestmentsCashOut,
            routes.hsaInvestmentsSecurityDetail,
          ]}
          title="Account details"
        >
          <BenefitDetailsPage />
        </Route>

        <Route
          exact
          path={[routes.hsaInvestmentsPortfolioAllocation, routes.hsaInvestmentsPortfolioAllocationSecurityDetail]}
          title="Portfolio allocation"
        >
          <PortfolioAllocationPage />
        </Route>

        <Route exact path={routes.reimbursements} title="Reimbursements">
          <ReimbursementsPage />
        </Route>

        <Route exact path={routes.upcomingEvents} title="Upcoming events">
          <UpcomingEvents />
        </Route>

        <Route exact path={routes.index} title="Accounts">
          <AccountsPage />
        </Route>
      </Switch>

      <Switch>
        <Suspense
          fallback={
            <Modal.Root open>
              <Modal.Title hidden aria-hidden>
                Loading
              </Modal.Title>
              <Modal.Content>
                <div className="w-full h-[200px] bg-grayscale-2 rounded-lg animate-pulse" />
              </Modal.Content>
            </Modal.Root>
          }
        >
          <Route exact path={routes.reimbursementTransferModal} title="Transfer funds">
            <TransferModal />
          </Route>

          <Route exact path={routes.eligibilityCategories} title="Eligible categories">
            <EligibilityCategories />
          </Route>

          <Route exact path={routes.policyOverview} title="Merchant guidelines">
            <PolicyOverview />
          </Route>

          <Route exact path={routes.benefitRules} title="Benefit rules">
            <BenefitRules />
          </Route>

          <Route exact path={routes.paymentMethods} title="Payment methods">
            <PaymentMethodsModal />
          </Route>

          <Route exact path={routes.bankDetails} title="Benefit rules">
            <BankDetails />
          </Route>

          <Route exact path={routes.hsaApplicationForm} title="Unit application form">
            <HSASubmitDocumentsModal />
          </Route>

          <Route exact path={routes.hsaInvestmentsInvestMore} title="Invest more">
            <InvestMoreModal />
          </Route>

          <Route exact path={routes.hsaInvestmentsCashOut} title="Cash out">
            <CashOutModal />
          </Route>

          <Route
            exact
            path={[routes.hsaInvestmentsSecurityDetail, routes.hsaInvestmentsPortfolioAllocationSecurityDetail]}
            title="Security detail"
          >
            <SecurityDetailModal />
          </Route>
        </Suspense>
      </Switch>
      <BannerBottomBar>
        <BannerContainer />
      </BannerBottomBar>
    </BannerProvider>
  </>
);

export default Accounts;
